import PellaCasementNoGrilleBlack from 'src/assets/img/homeownerApp/materialCategories/PellaCasementNoGrilleBlackThumbnail.webp';
import PellaCasementNoGrilleBrickRed from 'src/assets/img/homeownerApp/materialCategories/PellaCasementNoGrilleBrickRedThumbnail.webp';
import PellaCasementNoGrilleBrown from 'src/assets/img/homeownerApp/materialCategories/PellaCasementNoGrilleBrownThumbnail.webp';
import PellaCasementNoGrilleClassicWhite from 'src/assets/img/homeownerApp/materialCategories/PellaCasementNoGrilleClassicWhiteThumbnail.webp';
import PellaCasementNoGrilleFossil from 'src/assets/img/homeownerApp/materialCategories/PellaCasementNoGrilleFossilThumbnail.webp';
import PellaCasementNoGrilleHartfordGreen from 'src/assets/img/homeownerApp/materialCategories/PellaCasementNoGrilleHartfordGreenThumbnail.webp';
import PellaCasementNoGrilleIronOre from 'src/assets/img/homeownerApp/materialCategories/PellaCasementNoGrilleIronOreThumbnail.webp';
import PellaCasementNoGrilleMorningSkyGray from 'src/assets/img/homeownerApp/materialCategories/PellaCasementNoGrilleMorningSkyGrayThumbnail.webp';
import PellaCasementNoGrilleNaval from 'src/assets/img/homeownerApp/materialCategories/PellaCasementNoGrilleNavalThumbnail.webp';
import PellaCasementNoGrilleTan from 'src/assets/img/homeownerApp/materialCategories/PellaCasementNoGrilleTanThumbnail.webp';

export const PALETTE_THUMBNAILS_PELLA = {
  Fossil: PellaCasementNoGrilleFossil,
  'Classic White': PellaCasementNoGrilleClassicWhite,
  Tan: PellaCasementNoGrilleTan,
  'Iron Ore': PellaCasementNoGrilleIronOre,
  Black: PellaCasementNoGrilleBlack,
  Brown: PellaCasementNoGrilleBrown,
  'Brick Red': PellaCasementNoGrilleBrickRed,
  'Hartford Green': PellaCasementNoGrilleHartfordGreen,
  Naval: PellaCasementNoGrilleNaval,
  'Morning Sky Gray': PellaCasementNoGrilleMorningSkyGray,
} as const;
